import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

class DoughnutChartHitsSummary extends Component {
  getDataset() {
    const { total = [] } = this.props;

    const labels = Object.keys(total);
    const data = Object.values(total);

    return {
      labels: labels,
      datasets: [
        {
          label: 'Consumo',
          backgroundColor: ['rgba(75,192,192,0.4)', 'rgba(255, 99, 132, 0.2)', 'rgba(255, 206, 86, 0.2)'],
          borderColor: ['rgba(75,192,192,1)', 'rgba(255, 99, 132, 1)', 'rgba(255, 206, 86, 1)'],
          borderWidth: 1,
          data: data,
        },
      ],
    };
  }

  render() {
    const data = this.getDataset();

    return (
      <Doughnut
        height={100}
        data={data}
      />
    );
  }
}

export default DoughnutChartHitsSummary;
